<template>
  <StatisticsAnalysisPage />
</template>

<script>
// @ is an alias to /src
import StatisticsAnalysisPage from "@/components/statistics/StatisticsAnalysisPage.vue";

export default {
  name: "StatisticsAnalysis",
  components: {
    StatisticsAnalysisPage,
  },
};
</script>

<style scoped>
::v-deep .container--fluid {
  padding: 0px !important;
}
</style>